!((document, Drupal, $, Cookies) => {
  'use strict';

  /**
   * This function is set up to toggle the alert message shut.
   */
  Drupal.behaviors.alertBox = {
    attach(context) {
      if (context !== document) {
        return;
      }

      let $alertMessages;
      const self = this;

      $(document).ready(function() {
        $alertMessages = $('.alert-message');

        $alertMessages.each(function() {
          const $alertMessage = $(this);
          const id = $alertMessage.attr('data-alert-id');

          if (!id.length) {
            return;
          }

          // Retrieve the cookie and check state on load.
          const cookie = Cookies.get('alertMessage__' + id);

          if (cookie !== 'dismissed') {
            $alertMessage.addClass('active');
          }

          // Toggle to dismiss the alert
          $alertMessage.on('click', '.close-btn', function() {
            self.dismissAlert($alertMessage, id);
          });
        });

        // move alert to same place in layout edit page
        const $alertLayoutPage = $(
          '.page-layout-container .layout-content .alert-message',
          context
        );
        const $alertLayoutPageSize = $alertLayoutPage.length;
        if ($alertLayoutPageSize > 1) {
          $alertLayoutPage.each((i, e) => {
            if (i < $alertLayoutPageSize - 1) {
              $(e).insertBefore($($alertLayoutPage)[$alertLayoutPageSize - 1]);
            }
          });
        }
      });
    },

    dismissAlert($alertMessage, id) {
      $alertMessage.removeClass('active');
      Cookies.set('alertMessage__' + id, 'dismissed');
      $alertMessage.trigger('alert:dismissed');
    }
  };
})(document, Drupal, jQuery, window.Cookies);
